<template>
    <card class="bg-light">
        <template #default>
            <card-body>
                <div v-if="galleryMedia" class="mb-2 d-flex align-items-start justify-content-between">
                    <div>
                        {{ name }} {{ location ? ' - '+location : '' }}
                    </div>
                    <photo-icon :size="24" class="ms-auto clickable" @click="showGallery=true"/>

                    <vertical-gallery-modal v-if="showGallery" :media="galleryMedia" @close="showGallery=false">
                        {{ name }}
                    </vertical-gallery-modal>
                </div>
                <div v-else class="mb-2">{{ name }} {{ location ? ' - '+location : '' }}</div>
                <div class="small text-muted">
                    {{ features }}
                </div>
            </card-body>
        </template>
    </card>
</template>

<script type="text/javascript">
    import PhotoIcon from '@/assets/icons/photo.svg.vue';
    import CommonComponents from '@/components/Common.vue';
    
    import RoomsConfig from '@/config/rooms.json';

    import Formatter from '@/classes/Formatter.js';
    import ApiObject from '@/classes/ApiObject.js';
    import Media from '@/classes/Media.js';

    export default {

        components: {
            PhotoIcon,
            ...CommonComponents,
        },


        data() {
            return {
                showGallery: false,
            };
        },

        props: {
            bedroom: {
                type: ApiObject,
                required: true,
            },

            property: {
                type: ApiObject,
                required: true,
            },

            // used when the room doesn't have a name
            num: {
                type: Number,
            },
        },

        computed: {
            name() {
                if (
                    (this.bedroom) &&
                    (this.bedroom.name)
                ) {
                    return this.bedroom.name;
                }

                if (this.num) {
                    return 'Bedroom #'+this.num;
                }
                return 'Bedroom';
            },

            location() {
                if (this.bedroom) {
                    let arr = [];
                    if (this.bedroom.floor) {
                        arr.push(this.bedroom.floor);
                    }
                    if (this.bedroom.location) {
                        arr.push(this.bedroom.location);
                    }

                    if (arr.length) {
                        return arr.join(', ');
                    }
                }
                return null;
            },

            features() {

                let arr = [];

                if (
                    (this.bedroom) && 
                    (this.bedroom.subtype) &&
                    (RoomsConfig.bedroomsSubtypes[this.bedroom.subtype]) &&
                    (RoomsConfig.bedroomsSubtypes[this.bedroom.subtype] != 'Bedroom')
                ) {
                    arr.push(RoomsConfig.bedroomsSubtypes[this.bedroom.subtype]);
                }

                if (
                    (this.bedroom) &&
                    (this.bedroom.components) &&
                    (this.bedroom.components.length)
                ) {
                    for (let i=0; i<this.bedroom.components.length; i++) {
                        arr.push((this.bedroom.components[i].quantity || 1)+' '+this.bedType(this.bedroom.components[i]));
                    }
                }

                if (
                    (this.bedroom) &&
                    (this.bedroom.features) &&
                    (this.bedroom.features.length)
                ) {
                    
                    for (let i=0; i<this.bedroom.features.length; i++) {
                        let val = this.bedroom.features[i].feature;
                        if (val == 'Television') {
                            val = 'TV';
                        }
                        else if (val == 'Balcony') {
                            val = 'Balcony/Deck';
                        }
                        if ((this.bedroom.features[i].options) && (this.bedroom.features[i].options.length)) {
                            val = this.bedroom.features[i].options.join(' ')+' '+val;
                        }
                        arr.push(val);
                    }
                }

                if (arr.length > 0) {
                    if (arr.length <= 2) {
                        return arr.join(' and ');
                    }
                    else  {
                        arr[arr.length - 1] = 'and '+arr[arr.length - 1];
                        return arr.join(', ');
                    }
                }
                return null;
            },

            galleryMedia() {
                let gallery = [];

                if (
                    (this.property) &&
                    (this.property.photos) &&
                    (this.property.photos.length)
                ) {
                    
                    for (let i=0; i<this.property.photos.length; i++) {
                        if (this.property.photos[i].bedroomId == this.bedroom.id) {
                            let thumb = this.property.photos[i].galleryThumbSource;
                            let src = this.property.photos[i].gallerySource || thumb;

                            let media = new Media(thumb, src, null, 'image');
                            media.title = this.property.photos[i].title;
                            media.description = this.property.photos[i].content;
                            media.setSize(this.property.photos[i].width, this.property.photos[i].height, {width:2000, height:1125});
                            gallery.push(media);
                        }
                    }
                    
                }

                if (gallery.length) {
                    return gallery;
                }

                return null;

            },
        },

        methods: {
            bedType(bed) {
                if (
                    (RoomsConfig) &&
                    (RoomsConfig.bedTypes) &&
                    (RoomsConfig.bedTypes[bed.type])
                ) {
                    let bedPostfix = ' bed';
                    if (
                        (RoomsConfig.bedTypes[bed.type].toLowerCase().indexOf('bed') != -1) ||
                        (RoomsConfig.bedTypes[bed.type].toLowerCase().indexOf('soft') != -1)
                    ) {
                        bedPostfix = '';
                    }
                    return Formatter.pluralize(bed.quantity || 1, RoomsConfig.bedTypes[bed.type]+bedPostfix+'s', RoomsConfig.bedTypes[bed.type]+bedPostfix);
                }
                return Formatter.pluralize(bed.quantity || 1, 'Beds', 'Bed');
            }
        },
    };

</script>
